import { $DataModuleName } from "@omni/types/utils/store";
import { combineReducers } from "redux";

import { initializingReducer } from "@/redux/initialState";
import {
    $BillingCountriesModuleName,
    TBillingCountriesState
} from "@/redux/modules/api/data/countries/billing/billingCountries.types";
import {
    $PhonenumberPrefixesModuleName,
    TPhonenumberPrefixesState
} from "@/redux/modules/api/data/phonenumberPrefixes/phonenumberPrefixes.types";
import {
    $ShopNamesModuleName,
    TShopNamesState
} from "@/redux/modules/api/data/stores/shopNames/shopNames.types";
import {
    $VatPrefixesModuleName,
    TVatPrefixesState
} from "@/redux/modules/api/data/vatPrefixes/vatPrefixes.types";
import createReducerManager from "@/redux/reducerManager";
import {
    IApiDataState,
    IValueState,
    TApiAction,
    TApiDataStateSlice,
    TValueAction
} from "@/redux/store.types";

import ApiErrorsModule from "./api/errors/errors.reducer";
import { $ApiErrorsModuleName } from "./api/errors/errors.types";
import LoadingModule from "./api/loading/loading.reducer";
import { $LoadingModuleName } from "./api/loading/loading.types";
import { $ErrorsModuleName, TErrorsState } from "./value/errors/errors.types";
import {
    $FlyoutCategoriesModuleName,
    FlyoutCategory
} from "./value/flyoutCategories/flyoutCategories.types";
import {
    $PaintCollectionModuleName,
    TPaintCollectionState
} from "./value/paintCollection/paintCollection.types";
import {
    $ProductDetailModuleName,
    TProductDetailState
} from "./value/productDetail/productDetail.types";
import { $SearchModuleName, SearchState } from "./value/search/search.types";
import {
    $TranslationsModuleName,
    TTranslationsState
} from "./value/translations/translations.types";

export const apiDataReducerManager = createReducerManager<
    IApiDataState,
    TApiAction
>({
    [$ShopNamesModuleName]: initializingReducer<
        TApiDataStateSlice<TShopNamesState>,
        IApiDataState,
        TApiAction
    >($ShopNamesModuleName),
    [$BillingCountriesModuleName]: initializingReducer<
        TApiDataStateSlice<TBillingCountriesState>,
        IApiDataState,
        TApiAction
    >($BillingCountriesModuleName),
    [$VatPrefixesModuleName]: initializingReducer<
        TApiDataStateSlice<TVatPrefixesState>,
        IApiDataState,
        TApiAction
    >($VatPrefixesModuleName),
    [$PhonenumberPrefixesModuleName]: initializingReducer<
        TApiDataStateSlice<TPhonenumberPrefixesState>,
        IApiDataState,
        TApiAction
    >($PhonenumberPrefixesModuleName)
});

export const apiReducer = combineReducers({
    [$LoadingModuleName]: LoadingModule,
    [$ApiErrorsModuleName]: ApiErrorsModule,
    [$DataModuleName]: apiDataReducerManager.reduce
});

export const valueReducerManager = createReducerManager<
    IValueState,
    TValueAction
>({
    [$TranslationsModuleName]: initializingReducer<
        TTranslationsState,
        IValueState,
        TValueAction
    >($TranslationsModuleName),
    [$ProductDetailModuleName]: initializingReducer<
        TProductDetailState,
        IValueState,
        TValueAction
    >($ProductDetailModuleName),
    [$FlyoutCategoriesModuleName]: initializingReducer<
        FlyoutCategory,
        IValueState,
        TValueAction
    >($FlyoutCategoriesModuleName),
    [$ErrorsModuleName]: initializingReducer<
        TErrorsState,
        IValueState,
        TValueAction
    >($ErrorsModuleName),
    [$SearchModuleName]: initializingReducer<
        SearchState,
        IValueState,
        TValueAction
    >($SearchModuleName),
    [$PaintCollectionModuleName]: initializingReducer<
        TPaintCollectionState,
        IValueState,
        TValueAction
    >($PaintCollectionModuleName)
});
